import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PaginationBlock from './PaginationBlock';

import './PaginationWidget.scss';

const noop = function(){};
const className = 'PaginationWidget';
const pagesClass = `${className}__pages`;
const dotsClassName = `${className}__Dots`;

class PaginationWidget extends Component {

	constructor(props) {
		super(props);

		this.onDecrementPage = this.onDecrementPage.bind(this);
		this.onIncrementPage = this.onIncrementPage.bind(this);
		this.setPageIndex    = this.setPageIndex.bind(this);

		this.state = {
			windowIndex : determineStartingWindowIndex(props.currentPageIndex || 0),
			...PaginationWidget.getPageVisibilityState(props),
		};
	}

	/*
	* If user applies filters (or something else happens) and number of pages changes,
	* Result set is different so set current page to 0 and start user at beginning.
	*/
	componentWillReceiveProps(nextProps) {
		if (this.props.numberOfPages !== nextProps.numberOfPages) {
			this.setPageIndex(0, this.props.currentPageIndex);
		}

		this.setState({
			...PaginationWidget.getPageVisibilityState(nextProps)
		});
	}

	static getPageVisibilityState(props) {
		const firstLast             = determineMinMaxPages(props.currentPageIndex, props.pagesToShow, props.numberOfPages);
		const showFirstLastControls = props.numberOfPages > props.pagesToShow;
		const isFirstPageVisible    = showFirstLastControls && firstLast.firstPage > 0;
		const isLastPageVisible     = showFirstLastControls && (firstLast.lastPage + 1) < props.numberOfPages;
		const isPrevDotsVisible     = showFirstLastControls && getIsPrevDotsVisible(firstLast.firstPage, 1);
		const isPrevDotsPage        = showFirstLastControls && getIsPrevDotsPage(firstLast.firstPage, 1);
		// -1 adjust for 0 based index
		const isNextDotsVisible     = showFirstLastControls && getIsNextDotsVisible(props.numberOfPages, firstLast.lastPage);
		const isNextDotsPage        = showFirstLastControls && getIsNextDotsPage(props.numberOfPages, firstLast.lastPage);

		return {
			...firstLast,
			isPrevDotsVisible,
			isPrevDotsPage,
			isNextDotsVisible,
			isNextDotsPage,
			isFirstPageVisible,
			isLastPageVisible,
		}
	}

	/*
	* If there are no results when a filter is applied, set current page to 0
	* Same logic as when the number of pages change. New results set so start at beginning
	*
	* IF this is needed, it should be moved to a container component
	// */
	// componentWillUnmount() {
	// 	this.setPageIndex(0, this.props.currentPageIndex);
	// }

	// RENDER METHODS //
	render() {
		const props = this.props;

		if (props.numberOfPages <= 1) {
			return null;
		}

		const isFirstPageVisibleClass = this.state.isFirstPageVisible ? `${className}--firstPageVisible` : '';
		const isLastPageVisibleClass  = this.state.isLastPageVisible ? `${className}--lastPageVisible` : '';

		return (
			<nav className={`${className} ${isFirstPageVisibleClass} ${isLastPageVisibleClass}`}>
				{PaginationWidget.renderPageControl(`${className}__PrevPage`, 'icon-left-arrow-thick', this.onDecrementPage, this.decrementIsActive())}
				<div className={`${pagesClass} ${pagesClass}--first`}>
					{this.renderFirstPage(props.currentPageIndex)}
					{this.state.isPrevDotsVisible ? PaginationWidget.renderDots(this.state.isPrevDotsPage, props.currentPageIndex, this.props.generatePageUrl, this.setPageIndex) : null}
				</div>
				{this.renderPageBlocks(props.numberOfPages, props.currentPageIndex)}
				<div className={`${pagesClass} ${pagesClass}--last`}>
					{this.state.isNextDotsVisible ? PaginationWidget.renderDots(this.state.isNextDotsPage, props.currentPageIndex, this.props.generatePageUrl, this.setPageIndex) : null}
					{this.renderLastPage(props.currentPageIndex)}
				</div>
				{PaginationWidget.renderPageControl(`${className}__NextPage`, 'icon-right-arrow-thick', this.onIncrementPage, this.incrementIsActive())}
			</nav>
		);
	}

	static renderPageControl(pageClass, icon, onClickFn, isActive) {
		const blockClass  = `${className}__block ${className}__block--alone`;
		const isActiveClass = isActive ? 'sdk-secondary-cta' : `${className}__block--disabled`;

		return (
			<button
				className={`${className}__control ${pageClass} ${blockClass} ${isActiveClass}`}
				onClick={onClickFn}
			>
				<i className={`${className}__innerBlock ${icon}`} />
			</button>
		);
	}

	static renderDots(page, currentPageIndex, generatePageUrl, setPageIndex) {
		const inactiveClass = !page ? `${dotsClassName}--Inactive` : '';

		return (
			<PaginationBlock
				className={`${dotsClassName} ${inactiveClass}`}
				setPageIndex={page ? setPageIndex : noop}
				page={page ? page : -1}
				currentPageIndex={currentPageIndex}
				url={page ? generatePageUrl(page + 1) : ''}
			>
				{page ? null : `...`}
			</PaginationBlock>
		)
	}

	renderFirstPage(currentPageIndex) {
		if (!this.state.isFirstPageVisible) {
			return null;
		}

		return (
			<PaginationBlock
				currentPageIndex={currentPageIndex}
				page={0}
				setPageIndex={this.setPageIndex}
				url={this.props.generatePageUrl(1)}
			/>
		)
	}

	renderLastPage(currentPageIndex) {
		if (!this.state.isLastPageVisible) {
			return null;
		}

		return (
			<PaginationBlock
				currentPageIndex={currentPageIndex}
				page={this.props.numberOfPages - 1}
				setPageIndex={this.setPageIndex}
				url={this.props.generatePageUrl(this.props.numberOfPages)}
			/>
		)
	}

	renderPageBlocks(numberOfPages, currentPageIndex) {
		let blocks = [];
		for (let i = 0; i < numberOfPages; i++) {
			if (this.isPageVisible(i)) {
				blocks.push(
					<PaginationBlock
						key={i}
						currentPageIndex={currentPageIndex}
						page={i}
						setPageIndex={this.setPageIndex}
						url={this.props.generatePageUrl(i+1)}
					/>
				);
			}
		}
		return (
			<div className={`${pagesClass} ${pagesClass}--center`}>
				{blocks}
			</div>
		);
	}

	// SETTERS
	setPageIndex(newIndex, currentPageIndex) {
		if (newIndex !== currentPageIndex) {
			this.props.onPageChange(newIndex);
		}
	}

	onDecrementPage() {
		if (this.decrementIsActive()) {
			const newIndex = this.props.currentPageIndex - 1;
			this.setPageIndex(newIndex, this.props.currentPageIndex);
			this.setState({ windowIndex : this.state.windowIndex - 1 });
		}
	}

	onIncrementPage() {
		if (this.incrementIsActive()) {
			const newIndex = this.props.currentPageIndex + 1;
			this.setPageIndex(newIndex, this.props.currentPageIndex);
			this.setState({ windowIndex : this.state.windowIndex + 1 });
		}
	}

	// STATE HELPERS

	decrementIsActive() {
		return this.props.currentPageIndex !== 0;
	}

	incrementIsActive() {
		return this.props.currentPageIndex !== this.props.numberOfPages - 1;
	}

	isPageVisible(page) {
		return (page >= this.state.firstPage && page <= this.state.lastPage);
	}
}

/*
 * Calculate window index on mount in the case staring page index is not 0
 * Start the index two indices before to make sure earlier page blocks are displayed
 */
function determineStartingWindowIndex(currentPageIndex) {
	return Math.max(0, currentPageIndex - 2);
}

function determineMinMaxPages(pageIndex, pagesToShow, totalPages) {
	const pageBlocksToDivide = (pagesToShow - 1) / 2;
	const prevPagesToShow = Math.floor(pageBlocksToDivide);
	const nextPagesToShow = Math.ceil(pageBlocksToDivide);
	let firstPage = Math.max(0, pageIndex - prevPagesToShow);
	let lastPage = Math.min(totalPages - 1, pageIndex + nextPagesToShow);

	if (firstPage === 0) {
		lastPage = pagesToShow - 1;
	}

	if (lastPage === totalPages -1) {
		firstPage = totalPages - pagesToShow;
	}

	return {
		firstPage,
		lastPage
	}
}

function getIsNextDotsVisible(numberOfPages, lastPage) {
	return (lastPage < numberOfPages - 2);
}

function getIsNextDotsPage(numberOfPages, lastPage) {
	return lastPage === numberOfPages - 3 ? lastPage + 1 : 0;
}

function getIsPrevDotsVisible(firstPage, minPage) {
	return (firstPage > minPage);
}

function getIsPrevDotsPage(firstPage, minPage) {
	return (firstPage === minPage + 1) ? firstPage - 1 : 0;
}


PaginationWidget.defaultProps = {
	generatePageUrl: function(){},
};

PaginationWidget.propTypes = {
	currentPageIndex  : PropTypes.number,
	numberOfPages     : PropTypes.number,
	pagesToShow       : PropTypes.number,
	onPageChange      : PropTypes.func,
	generatePageUrl   : PropTypes.func,
};

export default PaginationWidget;



// WEBPACK FOOTER //
// ./src/frontend-standard-library/modules-react/Base/Component/PaginationWidget/PaginationWidget.js